export const unaryTrim = (str: Maybe<string>) => (str || '').trim()
